import { TabletValues } from "../types/index-type";

export const initTabletValue = (): TabletValues => {
  const sidebarColumnsPortrait = 45;
  const mainColumnsPortrait = 55;

  const wholeLeftPositionOpen = 0;
  const wholeLeftPositionCloseLandscape = -26;
  const wholeLeftPositionClosePortrait = -40;

  const sidebarColumnsLandscape = 30;
  const mainColumnsLandscape = 70;
  const mainColumnsFillwidth = 96;

  return {
    sidebarColumnsPortrait,
    mainColumnsPortrait,
    wholeLeftPositionOpen,
    wholeLeftPositionCloseLandscape,
    wholeLeftPositionClosePortrait,
    sidebarColumnsLandscape,
    mainColumnsLandscape,
    mainColumnsFillwidth,
  };
};
